import { PAGE_LIMIT } from "constants";

const isTableAction = action => action.table !== undefined;

export const tableActionsEnum = {
  setColumnsVisibility: 'TABLE_SET_COLUMNS_VISIBILITY',
  setColumnsSizing: 'TABLE_SET_COLUMNS_SIZING',
  setColumnPinning: 'TABLE_SET_COLUMN_PINNING',
  setOrder: 'TABLE_SET_ORDER',
  setFilter: 'TABLE_SET_FILTER',
  setGlobalPageSize: 'TABLE_SET_GLOBAL_PAGE_SIZE',
  refreshTable: 'TABLE_REFRESH_TABLE',
};

const table = (state = {}, action) => {
  switch (action.type) {
    case tableActionsEnum.setColumnsVisibility:
      return {
        ...state,
        columnVisibility: action.table.columnVisibility,
      };

    case tableActionsEnum.setColumnsSizing:
      return {
        ...state,
        columnSizing: action.table.columnSizing,
      };
    case tableActionsEnum.setColumnPinning:
      return {
        ...state,
        columnPinning: action.table.columnPinning,
      };
    case tableActionsEnum.setOrder:
      return {
        ...state,
        columnOrder: action.table.columnOrder,
      };
    case tableActionsEnum.refreshTable:
      return {};
    default:
      return state;
  }
}

export const tableActions = {
  setColumnsVisibility: (id, columnVisibility) => {
    return {
      type: tableActionsEnum.setColumnsVisibility,
      table: {
        id,
        columnVisibility,
      },
    };
  },
  setColumnsSizing: (id, columnSizing) => {
    return {
      type: tableActionsEnum.setColumnsSizing,
      table: {
        id,
        columnSizing,
      },
    };
  },
  setColumnPinning: (id, columnPinning) => {
    return {
      type: tableActionsEnum.setColumnPinning,
      table: {
        id,
        columnPinning,
      },
    };
  },
  setColumnsOrder: (id, columnOrder) => {
    return {
      type: tableActionsEnum.setOrder,
      table: {
        id,
        columnOrder,
      },
    };
  },
  setGlobalPageSize: (pageSize) => {
    return {
      type: tableActionsEnum.setGlobalPageSize,
      pageSize,
    };
  },
};

export default (state = { globalPageSize: PAGE_LIMIT }, action) => {
  if (action.type === tableActionsEnum.setGlobalPageSize) {
    return {
      ...state,
      globalPageSize: action.pageSize,
    };
  }
  
  if (isTableAction(action)) {
    return {
      ...state,
      [action.table.id]: table(state[action.table.id], action),
    };
  }
  return state;
};
